import React, { useCallback } from "react";
import { Form, Button, DatePicker, Space } from "antd";
import { useStore, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import PolygonFormItem from "../PolygonFormItem";
import styles from "./index.module.less";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

function ImageryExtractionForm() {
  const { t } = useTranslation();
  const { select, dispatch } = useStore();
  const imageries = useSelector(select.layer.selectImageries);
  const loading = useSelector(select.layer.selectLoading);
  const compute = useCallback(
    (values) => {
      dispatch.layer.extract(values);
    },
    [dispatch]
  );
  const onChange = useCallback(
    (allFields) => {
      console.log(allFields);
      const payload = allFields.reduce((accumulator, currentValue) => {
        if (currentValue.name === "time") {
          return {
            ...accumulator,
            time: currentValue.value.format("YYYY-MM-DD"),
          };
        } else {
          const { drawing, polygon } = currentValue.value;
          return { ...accumulator, drawing, polygon };
        }
      }, {});
      dispatch.layer.updateImageries(payload);
    },
    [dispatch]
  );
  const checkVertex = (_, value) => {
    if (value.polygon?.length === 2) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("boundaryValidator")));
  };
  const reset = useCallback(() => {
    dispatch.layer.reset();
    dispatch.panel.reset();
  }, [dispatch]);
  return (
    <div className={styles.imageryExtractionForm}>
      <Form
        {...layout}
        fields={imageries}
        size="large"
        onFinish={compute}
        onFieldsChange={(_, allFields) => {
          onChange(allFields);
        }}
        name="imagery-extraction-form"
      >
        <Form.Item name="time" label={t("startDate")}>
          <DatePicker
            style={{ width: "100%" }}
            disabledDate={(current) => {
              return !current.isSame("2021-09-10", "month");
            }}
          />
        </Form.Item>
        <Form.Item
          name="vertex"
          label={t("boundary")}
          rules={[
            {
              validator: checkVertex,
            },
          ]}
        >
          <PolygonFormItem />
        </Form.Item>
        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {t("submit")}
            </Button>
            <Button htmlType="button" onClick={reset}>
              {t("reset")}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
}

export default ImageryExtractionForm;
